import TileGridContainer from 'features/tiles/tileGridContainer';
import { FC, useMemo, useState } from 'react';
import TileWithoutDefaultStyling from 'features/tiles/tileWithoutDefaultStyling';
import { useGetDataScienceTasksQuery } from 'app/apis/queryApi';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/store';
import Spinner from 'common/components/loading/spinner';
import DataScienceTasksTable from 'features/data-science/tasks-table/tasks-table';
import { onError } from 'features/toast/toast.slice';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import Button from 'common/components/buttons/button';
import { useNavigate } from 'react-router-dom';

export const SettingsDataScienceTasksPage: FC = () => {
  const { siteId } = useSelector((state: RootState) => state.selectedSite);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    data: dataScienceTasksData,
    isFetching: isFetchingDataScienceTasks,
    refetch
  } = useGetDataScienceTasksQuery({
    siteId
  });
  const dataScienceTasks = useMemo(() => {
    if (!isFetchingDataScienceTasks && dataScienceTasksData) {
      return dataScienceTasksData;
    }
    return [];
  }, [dataScienceTasksData, isFetchingDataScienceTasks]);

  const refreshTasks = () => {
    void refetch();
  };

  const createDataScienceTask = () => {
    navigate(`create`);
  };

  return (
    <TileGridContainer>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full grow basis-full">
        <section className="mx-6 my-6">
          <div className="flex items-center justify-between border-b border-neutral-200 pb-4 mb-4 mt-2">
            <span className="flex items-center">
              <h2 className="text-primary-700 text-l">Data Science Tasks</h2>
              <button onClick={refreshTasks}>
                <i className="ra-icons-generic-forward text-neutral-500 hover:text-primary-50 hover:border-primary-50 transition-all flex items-center w-fit text-sm ml-2"></i>
              </button>
            </span>
            <Button
              onClick={() => createDataScienceTask()}
              theme={ButtonTheme.PRIMARY}
              identifier="create-data-science-task"
            >
              <p>Create</p>
            </Button>
          </div>

          {isFetchingDataScienceTasks ? (
            <div className="flex justify-center">
              <Spinner />
            </div>
          ) : (
            <>
              {dataScienceTasks.length > 0 ? (
                <DataScienceTasksTable dataScienceTasks={dataScienceTasks} />
              ) : (
                <div>
                  <i className="ra-icons-generic-spanner-wrench text-neutral-500 text-4xl text-center block"></i>
                  <h2 className="text-center text-xl">No Data Science Tasks</h2>
                  <p className="text-center mt-1 text-sm">
                    You currently have no Data Science Tasks configured.
                  </p>
                </div>
              )}
            </>
          )}
        </section>
      </TileWithoutDefaultStyling>
    </TileGridContainer>
  );
};
